export interface ChangeEventSource {
  addEventListener(type: string, listener: () => void): void;
  removeEventListener(type: string, listener: () => void): void;
}

/** Browser events only request a sample from the existing poll owner. */
export class NetworkChangeSubscription {
  private sources: { ice?: ChangeEventSource; network?: ChangeEventSource } | undefined;
  private generation = 0;
  private pending = false;
  constructor(private readonly deps: { requestSample: () => void }) {}

  attach(sources: { ice?: ChangeEventSource; network?: ChangeEventSource }): void {
    if (this.sources?.ice === sources.ice && this.sources?.network === sources.network) return;
    this.dispose();
    this.sources = sources;
    sources.ice?.addEventListener('selectedcandidatepairchange', this.request);
    sources.network?.addEventListener('change', this.request);
  }

  dispose(): void {
    this.sources?.ice?.removeEventListener('selectedcandidatepairchange', this.request);
    this.sources?.network?.removeEventListener('change', this.request);
    this.sources = undefined;
    this.generation += 1;
    this.pending = false;
  }

  private readonly request = (): void => {
    if (this.pending || !this.sources) return;
    this.pending = true;
    const generation = this.generation;
    void Promise.resolve().then(() => {
      if (generation !== this.generation || !this.sources) return;
      this.pending = false;
      this.deps.requestSample();
    });
  };
}
